<div>
    @if (commonDataService.isOneTime) {
        <span class="btn-group ms-2 icon-pri-container importance-menu">
            @if (ticket.importance !== importanceEnum.low) {
                <sb-inline-svg
                    class="icon icon-pri"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'"
                    [ngClass]="{
                        'icon-pri-high': ticket.importance === importanceEnum.high,
                        'icon-pri-normal': ticket.importance === importanceEnum.medium,
                    }">
                </sb-inline-svg>
            }

            @if (ticket.importance === importanceEnum.low) {
                <sb-inline-svg
                    class="icon icon-pri icon-pri-low"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Priority icon down.svg'">
                </sb-inline-svg>
            }
        </span>
    }

    @if (!commonDataService.isOneTime && !commonDataService.user.isReadOnly) {
        <div class="btn-group ms-2 icon-pri-container importance-menu" dropdown>
            <span dropdownToggle class="pointer">
                @if (ticket.importance !== importanceEnum.low) {
                    <sb-inline-svg
                        class="icon icon-pri"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'"
                        [ngClass]="{
                            'icon-pri-high': ticket.importance === importanceEnum.high,
                            'icon-pri-normal': ticket.importance === importanceEnum.medium,
                        }">
                    </sb-inline-svg>
                }

                @if (ticket.importance === importanceEnum.low) {
                    <sb-inline-svg
                        class="icon icon-pri icon-pri-low"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Priority icon down.svg'">
                    </sb-inline-svg>
                }
            </span>

            <ul
                id="dropdown-basic"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-importance"
                role="menu"
                aria-labelledby="button-basic">
                <li role="menuitem">
                    <button
                        class="dropdown-item d-flex align-items-center"
                        type="button"
                        [disabled]="ticket.importance === importanceEnum.high"
                        (click)="updatePriority(importanceEnum.high)">
                        <sb-inline-svg
                            class="icon icon-pri icon-pri-high"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'">
                        </sb-inline-svg>
                        <span translate>High importance</span>
                    </button>
                </li>

                <li role="menuitem">
                    <button
                        class="dropdown-item d-flex align-items-center"
                        type="button"
                        [disabled]="ticket.importance === importanceEnum.medium"
                        (click)="updatePriority(importanceEnum.medium)">
                        <span class="icon"></span>
                        <span translate>Medium importance</span>
                    </button>
                </li>

                <li role="menuitem">
                    <button
                        class="dropdown-item d-flex align-items-center"
                        type="button"
                        [disabled]="ticket.importance === importanceEnum.low"
                        (click)="updatePriority(importanceEnum.low)">
                        <sb-inline-svg
                            class="icon icon-pri icon-pri-low"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Priority icon down.svg'">
                        </sb-inline-svg>
                        <span translate>Low importance</span>
                    </button>
                </li>
            </ul>
        </div>
    }
</div>
